export class FaqGroup {
  id?: string;
  name?: string;
  createdAt?: string;
  updatedAt?: string;
  constructor() {
  this.id = null;
  this.name = '';
  this.createdAt = '';
  this.updatedAt = '';
  }
}
